import React, { useEffect, useState } from 'react'
import JC from '../media/JC.png'
import { Link as RouterLink, useLocation } from 'react-router-dom'
import { Grid, Link, Typography } from '@mui/material';
import { getVersion } from '../services/apis';

export const Footer = () => {
    const location = useLocation();
    //---------------------------------------------------------------------------------------
    //---------------------------------------------------------------------------------------
    //---------------------------------------------------------------------------------------
    //--IMPORTANTE CAMBIAR LA VERSION AQUI Y EN LA TABLA version EN LA BBDD
    //---------------------------------------------------------------------------------------
    //---------------------------------------------------------------------------------------
    //---------------------------------------------------------------------------------------
    const versionLocal = '1.3.5';
    //---------------------------------------------------------------------------------------
    //---------------------------------------------------------------------------------------
    //---------------------------------------------------------------------------------------
    //---------------------------------------------------------------------------------------
    //---------------------------------------------------------------------------------------
    //---------------------------------------------------------------------------------------

    const [actualizado, setActualizado] = useState(false);

    const actualizarApp = () => {
        fetch(window.location.href, {
            headers: {
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache'
            }
        }).then(() => {
            window.location.href = window.location.href.split('?')[0] + '?updateApp=' + Date.now();
        });
    };

    useEffect(() => {
        const comprobarVersion = async () => {
            try {
                const response = await getVersion(versionLocal);

                if (response.success && response.actualizar && !actualizado) {
                    setActualizado(true);
                    actualizarApp();
                }
            } catch (error) {
                console.error("Error:", error);
            }
        };

        comprobarVersion();
    }, [actualizado, location.pathname, versionLocal]);

    return (
        <Grid
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
            size={{ xs: 12 }}
        >
            <Typography variant='caption'>&nbsp;Beta {versionLocal}</Typography>
            <Link
                component={RouterLink}
                to="/politica-de-privacidad"
                underline="hover"
                color="primary"
                sx={{ mt: 0.5, fontSize: "0.85rem" }}
            >
                Politica de privacidad
            </Link>
            {/* <img src={JC} alt="" style={{ maxWidth: '200px' }} onClick={() => window.open("https://www.jcinformatics.es/", "_blank")} /> */}
        </Grid>
    )
}
